// CONSTANTS are all caps.
const NS = 'PageFilter';
const CLS = 'pageFilter';
const WG = '.' + CLS + '-';

import utils from '../utils';

const { updateQueryStringParameter } = utils;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/pageFilter.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class PageFilter {

	constructor($el) {
		// $el is the widget node return by the loadPageFilter function
		this.$el = $($el);
	}

	init() {
		this.setPageFilter();
		this.handleSearchInput();
	}

	setPageFilter() {
		// Add Some logic here

		const ddItems = this.$el.find('.dropdown-menu .dropdown-item');
		const clearFilters = this.$el.find('.pageFilter-clrFilters');
		const selectedCls = 'is-selected';
		ddItems.on('click', function(e) {
			e.preventDefault();
			let selText = $(this).text();
			const parent = $(this).parents('.nav-item.dropdown');
			const filterType = parent.attr('data-filter-type');
			const filterValue = $(this).attr('data-filter-value') || "";
			parent.find('.dropdown-item').removeClass(selectedCls);
			$(this).addClass(selectedCls);
			selText.toLocaleLowerCase() === 'all' ? selText += ` ${filterType}` : '';
			parent.find('.dropdown-toggle').html(selText);
			window.location.href = utils.updateQueryStringParameter(window.location.href, filterType.toLowerCase(), filterValue);
		});

		clearFilters.on('click', function(e) {
			e.preventDefault();
			console.log('clicked');
			window.location.href = window.location.href.split('?')[0];
		});

	}

	handleSearchInput() {
		const $searchBtn = this.$el.find(WG + 'searchBtn');
		const $searchTxt = this.$el.find(WG + 'searchInput');
		const filterType = $searchTxt.attr('data-filter-type');

		let search = () => {
			let txt = $searchTxt.val();
			window.location.href = utils.updateQueryStringParameter(window.location.href, filterType.toLowerCase(), txt);
		};

		$searchBtn.on('click', function() {
			search();
		});

		$searchTxt.on('keypress', function(e) {
			if (e.keyCode == 13) {
				search();
			}
		});
	}

	//Add more functions like on above here

}
